<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="03" :question="question"></QuestionTitle>
        <div class="container-70">
            <MultipleInput :img="img" :listOfInput="listOfInput" v-model="result"></MultipleInput>
            <div v-if="result!=null" @click="saveAndContinue('organisationDetailCarburant', JSON.stringify(result), './question-4')" class="btn-primary d-block w-100 mt-50px text-center" >Suivant</div>
            <AvancementLine percent="33%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import MultipleInput from '@/components/MultipleInput.vue'
import AvancementLine from '@/components/AvancementLine.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Indiquez les dépenses de carburant ($) engendrées sur une période de 1 an par votre flotte de véhicules.',
            img:require('@/assets/images/carburant.png'),
            listOfInput:[
                'Véhicules légers',
                'Véhicules lourds'
            ]
        }
    },
    components: {
        QuestionTitle,
        MultipleInput,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('organisationDetailCarburant')){
            this.result=JSON.parse(sessionStorage.getItem('organisationDetailCarburant'))
        }
    }
}
</script>